'use strict'

import {ModelBase} from "../../../base/models";

class Analysis extends ModelBase {
	constructor(data, rootState) {
		super(data)

		this.project = rootState.projects.projects[data.project_id]
		this.panel = rootState.panels.panels.ids[data.panel_id]
	}
}

export {Analysis}